import { Box, Flex, Skeleton } from '@/components';
import type { FC } from 'react';

export const ProjectSearchSkeleton: FC = () => {
  return (
    <Box bordered padding={16} borderRadius={0} marginTop={16}>
      <Flex gap="4px 0" wrap="wrap" vertical>
        <Flex gap={8}>
          <Skeleton.Avatar active size="small" />
          <Skeleton.Input active size="small" />
        </Flex>
        <Flex
          style={{
            paddingLeft: 32,
          }}
        >
          <Skeleton.Input active size="large" />
        </Flex>
      </Flex>
    </Box>
  );
};
